import { Component, Input } from '@angular/core';
import { DsCardVariant, DsModule, Icons } from '@levelaccess/design-system';

import { $flaw } from '@shared/constants/flaw';
import { IFlawMobileOccurrenceHistory } from '@shared/interfaces/flaw.interface';
import { IAutomatedScanIssue } from '@shared/interfaces/scan-issues.interface';

import { CommonPipesModule } from '@client/app/shared/common-pipes.module';
import { PrettifyDatePipe } from '@client/app/pipes/prettify-date.pipe';
import { FlawService } from '@client/app/services/flaw.service';
import { IFindingChipConfig, IFindingChipGroup } from '@client/app/interfaces/finding.interface';

@Component({
  selector: 'app-finding-metadata-card',
  templateUrl: './finding-metadata-card.component.html',
  styleUrl: './finding-metadata-card.component.scss',
  standalone: true,
  imports: [DsModule, CommonPipesModule, PrettifyDatePipe],
})
export class FindingMetadataCardComponent {
  public readonly $flaw: typeof $flaw = $flaw;
  public readonly Icons: typeof Icons = Icons;
  public readonly DsCardVariant: typeof DsCardVariant = DsCardVariant;

  @Input()
  public chipGroups: IFindingChipGroup[] = [];

  @Input()
  public criteriaAndStandardLinks: IFindingChipConfig[] = [];

  @Input()
  public issue: IAutomatedScanIssue;

  @Input()
  public scanId: string;

  constructor(private flawService: FlawService) {}

  public getFlawPreviousStatus(): string {
    return this.flawService.getPreviousStatus(this.issue);
  }

  public getCurrentMobileOccurrenceCount(): number | undefined {
    const history: IFlawMobileOccurrenceHistory[] = this.issue?.[$flaw.mobileOccurrenceCount];
    return history?.find((entry: IFlawMobileOccurrenceHistory) => entry.scanId === this.scanId)?.count;
  }

  public getPreviousMobileOccurrenceCount(): number | null {
    const history: IFlawMobileOccurrenceHistory[] = this.issue?.[$flaw.mobileOccurrenceCount];
    const currentIndex: number = history?.findIndex((entry: IFlawMobileOccurrenceHistory) => entry.scanId === this.scanId) ?? -1;
    return currentIndex > 0 ? history[currentIndex - 1].count : null;
  }
}
